<!-- BOM物料 -->
<template>
  <BaseFormItem
    class="buy_bom"
    :label="fields.label"
    :labelTips="fields.labelTips"
    :isError="isError"
    :isErrorBlink="isErrorBlink"
  >
    <BaseRadioGroup v-model="val" @change="handleEmit">
      <el-radio
        border
        v-for="item in fields.options"
        :key="item.value"
        :label="item.value"
        class="buy_bom__radio"
      >
        {{ item.label }}
        <span v-if="item.desc" class="buy_bom__desc">
          {{ item.desc }}
        </span>
        <span v-if="item.badge" class="buy_bom__badge">
          {{ item.badge }}
        </span>
      </el-radio>
    </BaseRadioGroup>
    <!-- BOM文件、坐标文件上传 -->
    <div v-show="[1, 2, 4].includes(val)" class="buy_bom__upload">
      <i :class="['buy_bom__upload__linker', `linker_${val}`]"></i>
      <p class="buy_bom__upload__tips">
        <template v-if="val == 4">
          适合工程师等专业用户
        </template>
        <template v-else-if="val == 1">
          适合采购、新手等用户；如需<span>自供部分物料</span>，请在BOM文件内备注
        </template>
        <template v-else-if="val == 2">
          请在PCBA订单付款后及时寄出物料
        </template>
      </p>
      <div class="buy_bom__upload__list">
        <div class="buy_bom__upload__item">
          <p>
            BOM文件
            <BaseTextButton 
              v-if="val === 4 && +bomId"
              class="buy_bom__upload__item__btn" 
              @click="$refs.bomItemDialogRef.open(bomId)"
            >
              查看匹配详情
            </BaseTextButton>
            <span v-if="!bomId" class="buy_bom__upload__item__alert">
              请提供最新版本的生产BOM
            </span>
          </p>
          <UploadAndAnalyze 
            ref="bomUploadRef"
            type="bom"
            :accept="getUploadAccept('bom')"
            :fileUrl="bomFile.url"
            :fileName="bomFile.name"
            @change="handleBomFileChange"
            @beforeLogin="() => $emit('beforeLogin')"
          />
          <a @click="downloadTemplateUrl(0)">BOM模板下载</a>
        </div>
        <div class="buy_bom__upload__item">
          <p>
            坐标文件
            <span v-if="+isParsingCoordFromPCB===2" class="buy_bom__upload__item_banner buy_bom__upload__item__analyzing">
              <i class="icon-loading"></i>
              正在从PCB文件解析坐标文件...
            </span>
            <span v-else-if="+isParsingCoordFromPCB===5&&+coordStatus===-1" class="buy_bom__upload__item_banner buy_bom__upload__item_fail">
              解析失败，请手动上传
            </span>
            <template v-else-if="showTipsFlag">
              <span v-if="+coordStatus===1"  class="buy_bom__upload__item_banner buy_bom__upload__item_warning">
                PCB已变更，坐标已更新
              </span>
              <span v-else-if="+coordStatus===2"  class="buy_bom__upload__item_banner buy_bom__upload__item_fail">
                PCB已变更，请检查坐标文件
              </span>
            </template>
          </p>
          <UploadAndAnalyze 
            ref="smtUpload1"
            :newFlag = "true"
            :isParsingCoordFromPCB="isParsingCoordFromPCB"
            :isAutoAnalyze="isAutoAnalyze"
            :cacheFile="cacheFile"
            key="smtUpload1"
            :type="val === 4 ? 'one_stop' : 'smt'"
            :fileUrl="smtFile.url"
            :fileName="smtFile.name"
            :accept="getUploadAccept('coord')"
            :tips="tips"
            @change="handleSmtFileChange"
            @beforeLogin="() => $emit('beforeLogin')"
            @useCachedAnalysis="(data) => $emit('useCachedAnalysis',data)"
          />
          <a @click="downloadTemplateUrl(1)">坐标文件模板下载</a>
        </div>
      </div>
    </div>
    <!-- BOM订单列表 -->
    <div v-show="val === 3" class="buy_bom__list">
      <i class="buy_bom__list__linker"></i>
      <BomList 
        v-if="val === 3" 
        :item="currentItem" 
        @change="handleItemChange" 
      />
      <div class="buy_bom__list__upload">
        <span v-if="+isParsingCoordFromPCB===2" class="buy_bom__upload__item_banner buy_bom__upload__item__analyzing">
           <i class="icon-loading"></i>
          正在从PCB文件解析坐标文件...
        </span>
        <span v-else-if="+isParsingCoordFromPCB===5" class="buy_bom__upload__item_banner buy_bom__upload__item_fail">
          解析失败，请手动上传
        </span>
        <template v-else-if="showTipsFlag">
          <span v-if="+coordStatus===1"  class="buy_bom__upload__item_banner buy_bom__upload__item_warning">
            PCB已变更，坐标已更新
          </span>
          <span v-else-if="+coordStatus===2"  class="buy_bom__upload__item_banner buy_bom__upload__item_fail">
            PCB已变更，请检查坐标文件
          </span>
        </template>

        <UploadAndAnalyze 
          ref="smtUpload2"
          key="smtUpload2"
          type="smt"
          :newFlag = "true"
          :isParsingCoordFromPCB="isParsingCoordFromPCB"
          :isAutoAnalyze="isAutoAnalyze"
          :cacheFile="cacheFile"
          labelTips="上传坐标文件:"
          :fileUrl="smtFile.url"
          :fileName="smtFile.name"
          :accept="getUploadAccept('coord')"
          :tips="tips"
          @useCachedAnalysis="(data) => $emit('useCachedAnalysis',data)"
          @change="handleSmtFileChange"
          @beforeLogin="() => $emit('beforeLogin')"
        />
      </div>
    </div>
    <!-- BOM查看明细弹框 -->
    <BomItemDialog ref="bomItemDialogRef" />
  </BaseFormItem>
</template>

<script>
import BomList from '@@/components/bomList/index'
import UploadAndAnalyze from '../components/uploadAndAnalyze'
// BOM查看明细弹框
import BomItemDialog from '@@/views/submit/components/bomItemDialog'

import { getSMTFields } from '@@/utils/getFields'
import { bomSmtTemplateDownload } from '@@/api/pcba'
import {  isMyCenterSite } from '@@/utils/is'

export default {
  props: {
    value: {
      type: [Number, String],
      default: ''
    },
    item: {
      type: Object,
      default: () => ({})
    },
    bomFile: {
      type: Object,
      default: () => ({})
    },
    smtFile: {
      type: Object,
      default: () => ({})
    },
    // BOM选型id
    bomId: {
      type: [String, Number],
      default: ''
    },
    coordStatus: {
      type: Number,
      default: 0
    },
    customPcbBan: {
      type: Number,
      default: 1
    },
     // 是否正在从PCB解析坐标文件
    isParsingCoord: {
      type: Number,
      default: 0
    },
    isAutoAnalyze: {
      type: Boolean,
      default: false
    },
    cacheFile: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    BomList,
    UploadAndAnalyze,
    BomItemDialog
  },
  data() {
    return {
      val: this.value,
      currentItem: {},
      isError: false, // 是否显示错误提示样式
      isErrorBlink: false, // 是否显示错误提示样式且闪两下
      isParsingCoordFromPCB: 0,// 是否正在从PCB解析坐标文件 状态： 0-未开始, 1-上传中, 2-上传成功, 3-上传失败, 4-解析成功, 5-解析失败, 6-修改回显
      prevCoordStatus: null // 上一次coordStatus值
    }
  },
  computed: {
    fields() {
      return getSMTFields('buy_bom')
    },
    // 非 自助匹配选型 时，坐标文件可以上次压缩文件
    canUploadZip() {
      return this.val !== 4
    },
    tips(){
      let result =  this.val !== 4 ? '.zip、.rar、.xls、.xlsx、.csv、.txt 格式 (50M以内)' : '.xls、.xlsx、.csv、.txt格式 (50M以内)'
      // if(+this.val === 4){
      //   result = `${result}，不支持上传压缩文件`
      // }
      return result
    },
    showTipsFlag(){
      return +this.isParsingCoordFromPCB===4||this.customPcbBan===2
    },
     shouldShowCoordStatusBanner() {
      // 检查上一次的状态是否为isParsingCoordFromPCB=4且coordStatus为1或2
          return [1,2].includes(+this.prevCoordStatus) ;
    }
  },
  watch: {
    value(newVal) {
      this.val = newVal
    },
    item(item) {
      this.currentItem = item
    },
    // 监听是否正在解析坐标文件
    isParsingCoord: {
      handler(newVal) {
        // 保存前一个状态
        this.isParsingCoordFromPCB = newVal;
      },
      immediate: true
    },
    // 监听 smtFile 变化，确保 UploadAndAnalyze 组件能正确更新状态
    smtFile: {
      handler(newVal) {
        if (newVal && newVal.name) {
          // 更新所有可能的 UploadAndAnalyze 组件实例
          this.$nextTick(() => {
            const uploadRefs = [this.$refs.smtUpload1, this.$refs.smtUpload2];
            uploadRefs.forEach(ref => {
              if (ref) {
                // 直接设置 name 和 status，绕过 watch 的限制
                ref.name = newVal.name;
                ref.status = 6;
              }
            });
          });
        }
      },
      deep: true
    }
  },
  methods: {
    getPrevCoordStatus(status){
      this.prevCoordStatus = status
    },
    getUploadAccept(type) {
      // coord 坐标文件 bom BOM文件
      if(isMyCenterSite) {
        return '*'
      }
      if(type === 'coord') {
        return this.canUploadZip ? '.zip,.rar,.xls,.xlsx,.csv,.txt' : '.xls,.xlsx,.csv,.txt'
      }
      // bom默认就是组件内部支持格式所以返回undefined就行
    },
    // BOM、SMT模板下载
    downloadTemplateUrl(downloadType) {
      bomSmtTemplateDownload({ downloadType })
        .then(res => {
          if (!res) return
          const { retCode, result } = res
          if (retCode === 0) {
            window.open(result)
          }
        })
    },
    handleEmit() {
      const val = this.val
      this.$emit('input', val)
      this.handleEmitChange()
      this.handleResetUploadErrorStatus()
    },
    handleEmitChange() {
      const { val, currentItem } = this
      this.$emit('change', val, val === 3 && currentItem.bomSn ? currentItem : {})
      this.isShowError(false)
    },
    handleItemChange(item) {
      this.currentItem = item
      this.handleEmitChange()
    },
    // BOM文件上传成功
    handleBomFileChange(data) {
      this.$emit('bomFileChange', data)
      this.isShowError(false)
    },
    // 坐标文件上传成功
    handleSmtFileChange(data) {
      this.$emit('smtFileChange', data)
      this.isShowError(false)
    },
    // 是否显示错误提示样式
    isShowError(isShow, isBlink = false) {
      this.isError = isShow
      this.isErrorBlink = isBlink
    },
    // 重置上传失败状态
    handleResetUploadErrorStatus() {
      this.$refs.bomUploadRef && this.$refs.bomUploadRef.handleErrorReset()
      this.$refs.smtUpload1 && this.$refs.smtUpload1.handleErrorReset()
      this.$refs.smtUpload2 && this.$refs.smtUpload2.handleErrorReset()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@@/styles/mixin.scss';
.buy_bom__upload__item_banner{
  font-size: 12px;
  color: #999999;
  display: inline-flex;
  align-items: center;
  font-weight: normal;
  margin-left: auto;
  float: right;
}
.buy_bom__upload__item_fail{
  color:#FF4D4F;
}
.buy_bom__upload__item_warning{
  color:#E6A23C;
}
.buy_bom__upload__item__analyzing{
  .icon-loading{
    width: 16px;
    height: 16px;
    margin-right: 4px;
    background: url("~@@/assets/img/icons/loading-gif.svg") no-repeat no-repeat center;
    background-size: contain;
  }
}

.buy_bom {
  .buy_bom__radio {
    position: relative;
  }
  .buy_bom__desc {
    color: $--color-text-placeholder;
  }
  .buy_bom__badge {
    position: absolute;
    top: -14px;
    right: -2px;
    display: block;
    width: 24px;
    height: 18px;
    font-size: 12px;
    text-align: center;
    line-height: 18px;
    border-radius: 10px;
    border: 1px solid #DE533C;
    color: #DE533C;
    background-color: #fdf2f0;
  }
  .buy_bom__upload {
    position: relative;
    box-sizing: border-box;
    width: 630px;
    margin-top: 5px;
    padding: 12px 18px;
    border-radius: $--border-radius-base;
    // border: 1px dashed $--form-color-base;
    background-color: $--background-base;
    .buy_bom__upload__linker {
      @include moduleLinkerMixin(15px, vertical, dark);
      position: absolute;
      top: -10px;
      &.linker_1 {
        left: 126px;
      }
      &.linker_2 {
        left: 246px;
      }
      &.linker_4 {
        left: 6px;
      }
    }
    .buy_bom__upload__tips {
      line-height: 1.5;
      font-size: 12px;
      color: $--color-text-placeholder;
      >span {
        color: $--color-warning;
      }
    }
    .buy_bom__upload__list {
      display: flex;
      justify-content: space-between;
    }
    .buy_bom__upload__item {
      width: calc(50% - 8px);
      line-height: 1;
      >p {
        margin: 12px 0 8px;
        font-weight: 700;
        &::before {
          content: '* ';
          color: $--color-danger;
        }
        .buy_bom__upload__item__btn {
          padding: 0;
        }
        .buy_bom__upload__item__alert {
          margin-left: 10px;
          padding: 2px 8px;
          font-size: 12px;
          font-weight: 400;
          color: #E6A23C;
          border-radius: 4px;
          background-color: #FDF1D8;
        }
      }
      >a {
        display: block;
        margin-top: 8px;
        text-align: center;
        color: $--color-text-disabled;
        &:hover {
          text-decoration: underline;
        }
      }
    }
  }

  .buy_bom__list {
    position: relative;
    margin-top: 5px;
    .buy_bom__list__linker {
      @include moduleLinkerMixin(15px, vertical, dark);
      position: absolute;
      top: -10px;
      left: 246px;
    }
    .buy_bom__list__upload {
      margin-top: 10px;
    }
  }
}
</style>